import { Expose, Type } from 'class-transformer';
import { CreditsManagementTypeEnum } from '../../../../store/CreditsManagement/creditsManagementTypes';
import { CreditTypeDto } from './credit-type.dto';

export class CreditDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: CreditsManagementTypeEnum;
  @Expose({ name: 'is_repeat' })
  isRepeat: boolean;
  @Expose({ name: 'credit_type' })
  @Type(() => CreditTypeDto)
  creditType: CreditTypeDto;
}
